import {
  GPSForm,
  GPSLocation,
  GPSMode,
  Polygon,
} from '../../model/GeolocationNode'
import { Position } from './Position'

export class GPSLocationExtension implements GPSLocation {
  showLocation?: boolean | undefined
  label: string
  showLabel?: boolean | undefined
  mode: GPSMode
  distance?: number | undefined
  useDirection?: boolean | undefined
  minAngle?: number | undefined
  maxAngle?: number | undefined
  form?: GPSForm | undefined
  radius?: number | undefined
  long?: number | undefined
  lat?: number | undefined
  polygons?: Polygon[] | undefined

  constructor(
    showLocation: boolean,
    label: string,
    mode: GPSMode,
    distance?: number,
    useDirection?: boolean,
    minAngle?: number,
    maxAngle?: number,
    form?: GPSForm,
    radius?: number,
    long?: number,
    lat?: number,
    polygons?: Polygon[]
  ) {
    this.showLocation = showLocation
    this.label = label
    this.mode = mode
    this.distance = distance
    this.useDirection = useDirection
    this.minAngle = minAngle
    this.maxAngle = maxAngle
    this.form = form
    this.radius = radius
    this.long = long
    this.lat = lat
    this.polygons = polygons
  }

  static fromGPSLocation(location: GPSLocation) {
    return new GPSLocationExtension(
      location.showLocation ?? false,
      location.label,
      location.mode,
      location.distance,
      location.useDirection,
      location.minAngle,
      location.maxAngle,
      location.form,
      location.radius,
      location.long,
      location.lat,
      location.polygons
    )
  }

  private handleRelativeMode(
    currentPosition: Position,
    relativeLocation: Position
  ) {
    let direction
    if (!this.distance) return false

    if (
      this.useDirection &&
      typeof this.minAngle === 'number' &&
      typeof this.maxAngle === 'number'
    ) {
      direction = {
        min: this.minAngle,
        max: this.maxAngle,
      }
    }

    return currentPosition.isPositionRelative(
      relativeLocation,
      this.distance,
      direction
    )
  }

  private handleAbsoluteMode(currentPosition: Position) {
    switch (this.form) {
      case GPSForm.Circle:
        if (!this.radius) return false

        return currentPosition.isPositionInCircle(
          Position.fromGPSLocation(this),
          this.radius
        )
      case GPSForm.Polygon:
        if (!this.polygons || this.polygons.length === 0) return false

        for (let i = 0; i < this.polygons.length; i++) {
          const polygon = this.polygons[i]
          if (
            currentPosition.isPositionInPolygon(
              Position.polygonToArray(polygon)
            )
          )
            return true
        }

        return false
      default:
        return false
    }
  }

  checkLocation(currentPosition: Position, firstPosition: Position) {
    if (this.mode === GPSMode.Relative) {
      return this.handleRelativeMode(currentPosition, firstPosition)
    } else {
      return this.handleAbsoluteMode(currentPosition)
    }
  }
}
